import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { articulo } from '../models/articulos/alta-articulo'; 
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ArticulosService {

  constructor(private http: HttpClient) { }

   private API: string = 'http://172.16.1.50:3010';

  crearArticulo(dto: Omit<articulo, 'id'>){
    return this.http.post<{ok: boolean; articulo: articulo}>(`${this.API}/articulos`, dto)
  }

  obtenerArticulo(id: Number){
    return this.http.get<{ok: boolean, articulo: articulo}>(`${this.API}/articulos/${id}`);
  }

 listarArticulos() {
  return this.http.get<{ ok: boolean; articulos: articulo[] }>(`${this.API}/articulos`);
}

  actualizarArticulo(id: Number, payload: articulo){
    return this.http.put<any>(`${this.API}/articulos/${id}`, payload)
  }

}